<template>
  <ol
    class="flex items-center min-w-0 whitespace-nowrap"
    aria-label="Breadcrumb"
  >
    <li v-for="(item, k) in items" :key="k">
      <div v-if="k !== items.length - 1" class="flex items-center">
        <SvgIcon
          v-if="k === items.length - 2"
          name="angle-left-blue"
          class="pr-5 h-9.6 w-9.6 text-black-light lg:hidden"
        />
        <NuxtLink :class="itemClass(k, items.length)" :to="item.url">
          <span class="hidden lg:block">{{ item.text }}</span>
        </NuxtLink>
        <span class="hidden px-5 text-black-light lg:block">/</span>
      </div>
      <span v-else class="hidden lg:block"> {{ item.text }}</span>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => {
        return [
          {
            text: 'Home',
            url: '/',
          },
        ]
      },
    },
  },
  methods: {
    itemClass(k, length) {
      return [
        'underline text-blue hover:text-blue-dark',
        {
          'hidden lg:block': k !== length - 2,
          "before:content-['Indietro'] lg:before:content-[]": k === length - 2,
        },
      ]
    },
  },
}
</script>
